import { useState } from 'react';
import { getObraCustosAgregados } from '../services/api';

export interface Breadcrumb {
    id: number;
    nome: string;
}

export const useObraTabs = (obraId: string | undefined) => {
    const [activeTab, setActiveTab] = useState('balanco');
    const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);
    const [selectedInfo, setSelectedInfo] = useState<Breadcrumb | null>(null);

    const [activeAnaliseSubTab, setActiveAnaliseSubTab] = useState('categoria');

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setActiveTab(newValue);
        setBreadcrumbs([]);
        setSelectedInfo(null);
    };

    const handleItemClick = async (item: any) => {
        // Check if we are in the analysis tab and which sub-tab is active
        const isAnaliseTab = activeTab === 'analise';
        const isDrillDownSupported = isAnaliseTab && activeAnaliseSubTab === 'categoria';

        if (!isDrillDownSupported) {
            setSelectedInfo({ id: item.id, nome: item.nome });
            return;
        }

        try {
            const subCustos = await getObraCustosAgregados(Number(obraId), 'categoria', item.id);
            if (subCustos && subCustos.length > 0) {
                setBreadcrumbs(prev => [...prev, { id: item.id, nome: item.nome }]);
            } else {
                setSelectedInfo({ id: item.id, nome: item.nome });
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleBreadcrumbClick = (index: number) => {
        setBreadcrumbs(breadcrumbs.slice(0, index));
        setSelectedInfo(null);
    };

    return {
        activeTab,
        setActiveTab,
        activeAnaliseSubTab,
        setActiveAnaliseSubTab,
        breadcrumbs,
        selectedInfo,
        setSelectedInfo,
        handleTabChange,
        handleItemClick,
        handleBreadcrumbClick
    };
};
